import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AudanetTaskSearchResultItem } from '../../models/AudanetTaskSearchResultItem';
import { SearchAudanetTasksCriteria, SearchAudanetTasksCriteriaFormBuilder } from '../../models/SearchAudanetTasksCriteria';
import { SearchAudanetTasksType } from '../../models/SearchAudanetTasksType';
import { AudanetIntegrationService } from '../../service/audanet-integration.service';
import { AudanetOperationType } from '../../models/AudanetOperationType';
import { MediaService } from 'src/app/shared/services/media.service';

@Component({
  selector: 'app-show-associated-audanet-tasks',
  templateUrl: './show-associated-audanet-tasks.component.html',
  styleUrls: ['./show-associated-audanet-tasks.component.scss']
})
export class ShowAssociatedAudanetTasksComponent extends DialogContentBase implements OnInit {

  constructor(
    public dialog: DialogRef,
    private fb: UntypedFormBuilder, 
    private audanetIntegrationService:AudanetIntegrationService,
    private mediaService: MediaService
     ) { super(dialog);}

  @Input() searchCriteria: SearchAudanetTasksCriteria;
  @Input() claimIdentifier: string;
  @Input() audanetOperationType: AudanetOperationType;

  searchResult$: Observable<AudanetTaskSearchResultItem[]>;
  audanetSearchOngoing:boolean;

  searchType = 0;

  searchForm: UntypedFormGroup;

  ngOnInit(): void {
    this.searchForm = SearchAudanetTasksCriteriaFormBuilder.getForm(this.fb, this.searchCriteria);
    this.searchType = this.searchCriteria.searchType;
  }


  searchAudanetTasksTypeChange(ev: number) {
    this.searchType = ev;
  }

  search() {

    const criteria =this.searchCriteria;
    Object.assign(criteria, this.searchForm.value);
    
    if(criteria.searchType == SearchAudanetTasksType.ClaimNumber){
      criteria.plateNumber = '';
      criteria.vin = '';
    }

    if(criteria.searchType == SearchAudanetTasksType.VIN){
      criteria.plateNumber = '';
      criteria.claimNumber = '';
    }

    if(criteria.searchType == SearchAudanetTasksType.PlateNumber){
      criteria.vin = '';
      criteria.claimNumber = '';
    }

    this.audanetSearchOngoing = true;

    this.searchResult$ = this.audanetIntegrationService.searchAudanetTasks(criteria).pipe(
      tap(() => { this.audanetSearchOngoing = false; })
     );

  }

  openForCostEstimationImport(taskId:string){

    let webAppPath = '';
    if(environment.wepAppName){
      webAppPath = "/" + environment.wepAppName;
    }

    const width = this.mediaService.getFullHdRelativeWidth(0.75);
    const height = this.mediaService.getFullHdRelativeHeight(0.75);
    const link = window.location.origin + webAppPath + '/audanetIntegration/taskInfo/' + taskId + '/' + this.audanetOperationType + '/' + this.claimIdentifier;
    window.open(link,"_audanetTaskDetailsWindow",'left=200,top=50,width='+ width + ',height=' + height + ',toolbar=0,location=0,resizable=1,scrollbars=1'); return false;
    
  }

  selectTask( task:AudanetTaskSearchResultItem){
    this.dialog.close({ text: 'OK', selectedTask: task});
  }

  
}
